<template>
  <div>
    <div class="e-block__title">It looks like you may need some help!</div>
    <div class="e-block__text e-block__text--mb32">Based on what your input, it is recommended to reach out to our Customer Experience representatives for assistance.<br>How would you like to connect?</div>
    <div class="e-selector-block">
      <div class="e-selector-wrap">
        <div class="e-selector-column">
          <div class="e-selector e-selector--contact e-selector--phone" @click.prevent="nextQuestion(callUs)">Call a customer experience representative</div>
          <a class="e-selector e-selector--contact e-selector--email" :href="mailto">I prefer email</a>
          <div class="e-selector e-selector--contact e-selector--chat" v-if="showLiveChatBtn">Chat with us</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { callUs } from '@/utils/residential-flow';

export default {
  components: {},
  name: 'NeedHelpBlock',
  props: {
    noResults: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      callUs,
      mailto: `mailto:${process.env.VUE_APP_EMAIL}`,
      showLiveChatBtn: false,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(['nextQuestion']),
  },
};
</script>

<style lang="scss">

</style>
